(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.galleries = {
    attach: function (context, settings) {
      const galleryContainer = $('.gallery', context);
      galleryContainer.lightSlider({
        item: 1,
        pager: false,
        prevHtml: '<span class="gallery__prev"></span>',
        nextHtml: '<span class="gallery__next"></span>'
      });
    }
  };
})(window.Drupal, window.jQuery);
